import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import dropdownIcon from "../../../assets/images/dropdown.svg";
import {
  openPersonDropdownHandler,
  setIsPersonDropdownActive,
} from "../../../_actions/searchActions";
import GuestFields from "../../partials/GuestFields";
import { guestSummary } from "../../../helper/guests";

// Guests of the search bar: "Who" with a summary, opening the guest picker.
function Dropdown({ forView, showErrors = false, focusToken = 0 }) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { persons, isPersonDropdownActive: dropdownActive } = useSelector(
    (state) => state.search
  );
  const language = i18n?.resolvedLanguage || i18n?.language || "en";
  const dropdownActiveRef = useRef(dropdownActive);

  useEffect(() => {
    const bodyClass = "dropdown-open";
    if (dropdownActive) document.body.classList.add(bodyClass);
    else document.body.classList.remove(bodyClass);
    return () => document.body.classList.remove(bodyClass);
  }, [dropdownActive]);

  useEffect(() => {
    dropdownActiveRef.current = dropdownActive;
  }, [dropdownActive]);

  const dropdownRef = useRef(null);
  const toggleButtonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownActiveRef.current &&
        dropdownRef.current &&
        event.target.closest(".customDropdown.numberOfPerson") === null &&
        toggleButtonRef.current &&
        !toggleButtonRef.current.contains(event.target)
      ) {
        dispatch(setIsPersonDropdownActive(false));
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [dispatch]);

  return (
    <div
      className={`formGroup dropdownWrap mb0 ${dropdownActive ? "dropdown-active" : ""} ${
        showErrors ? "dropdownWrap--invalid" : ""
      }`}
    >
      <span
        ref={toggleButtonRef}
        className='dropdownButton guest-trigger'
        role='button'
        tabIndex={0}
        aria-expanded={dropdownActive}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          dispatch(openPersonDropdownHandler());
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            dispatch(openPersonDropdownHandler());
          }
        }}
      >
        <span className='guest-trigger__label'>{t("who", "Who")}</span>
        <span className='guest-trigger__value'>{guestSummary(t, language, persons)}</span>
      </span>

      <div
        className={`customDropdown numberOfPerson`}
        ref={dropdownRef}
        style={{ zIndex: "10000" }}
      >
        {forView === "mobile" && (
          <h2 className='blockLable'>
            {t("number_of_person")}
            <span
              className='icnClosed'
              onClick={(event) => {
                event.stopPropagation(); // prevent event from bubbling up
                dispatch(setIsPersonDropdownActive(false));
              }}
            >
              <i className='fa-solid fa-xmark'></i>
            </span>
          </h2>
        )}
        <GuestFields persons={persons} showErrors={showErrors} focusToken={focusToken} />
      </div>
      <img src={dropdownIcon} className='dropdownArrow' alt='dropdown' />
    </div>
  );
}

export default Dropdown;
